var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.image
        ? [
            _c("s3-image", {
              staticClass:
                "inline-block h-14 w-14 rounded-full object-cover object-center",
              attrs: { s3FileKey: _vm.image },
            }),
          ]
        : [
            _c(
              "span",
              {
                staticClass:
                  "inline-flex items-center justify-center h-14 w-14 rounded-full bg-gray-500",
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "text-xl font-medium leading-none text-white",
                  },
                  [_vm._v(_vm._s(_vm.initial))]
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }